export default new class CartRefreshEvent {
  callbacks = []

  addCallback (callback) {
    this.callbacks.push(callback)
  }

  exec () {
    this.callbacks.forEach((callback) => {
      callback()
    })
  }
}
